/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReportTab200ResponseProductsInnerAllOfDiscount
 */
export interface GetReportTab200ResponseProductsInnerAllOfDiscount {
    /**
     * 
     * @type {string}
     * @memberof GetReportTab200ResponseProductsInnerAllOfDiscount
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof GetReportTab200ResponseProductsInnerAllOfDiscount
     */
    value?: number;
}

/**
 * Check if a given object implements the GetReportTab200ResponseProductsInnerAllOfDiscount interface.
 */
export function instanceOfGetReportTab200ResponseProductsInnerAllOfDiscount(value: object): value is GetReportTab200ResponseProductsInnerAllOfDiscount {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GetReportTab200ResponseProductsInnerAllOfDiscountFromJSON(json: any): GetReportTab200ResponseProductsInnerAllOfDiscount {
    return GetReportTab200ResponseProductsInnerAllOfDiscountFromJSONTyped(json, false);
}

export function GetReportTab200ResponseProductsInnerAllOfDiscountFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportTab200ResponseProductsInnerAllOfDiscount {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function GetReportTab200ResponseProductsInnerAllOfDiscountToJSON(json: any): GetReportTab200ResponseProductsInnerAllOfDiscount {
    return GetReportTab200ResponseProductsInnerAllOfDiscountToJSONTyped(json, false);
}

export function GetReportTab200ResponseProductsInnerAllOfDiscountToJSONTyped(value?: GetReportTab200ResponseProductsInnerAllOfDiscount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'value': value['value'],
    };
}

